// src/pages/IncognitoPage.ts
import "./IncognitoPage.css";

export function renderIncognitoPage(): void {
  const app = document.getElementById("app");
  if (!app) return;

  document.title = "Incognito - AyeSearch";

  app.innerHTML = `
    <div class="incognito-wrapper">
      <main class="incognito-container">
        <section class="incognito-header">
          <div
            class="incognito-icon"
            aria-hidden="true"
          >
            <svg
              width="84"
              height="84"
              viewBox="0 0 96 96"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27 39L35 19H61L69 39"
                stroke="currentColor"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18 42H78"
                stroke="currentColor"
                stroke-width="5"
                stroke-linecap="round"
              />
              <circle
                cx="31"
                cy="58"
                r="10"
                stroke="currentColor"
                stroke-width="5"
              />
              <circle
                cx="65"
                cy="58"
                r="10"
                stroke="currentColor"
                stroke-width="5"
              />
              <path
                d="M41 58H55"
                stroke="currentColor"
                stroke-width="5"
                stroke-linecap="round"
              />
            </svg>
          </div>

          <h1>You’re incognito private</h1>

          <p class="main-description">
            Now you can browse privately, and other people who use this device
            won’t see your activity. However, downloads, bookmarks and reading
            list items will still be saved.
          </p>
        </section>

        <section class="info-grid" aria-label="Private browsing information">
          <article class="info-block light-block">
            <h3>What is private browsing?</h3>
            <p>
              Private browsing ensures your history, searches, and form data
              aren't saved locally on this device. It creates a temporary
              session that disappears the moment you close all private windows.
            </p>
          </article>

          <article class="info-block light-block">
            <h3>Your activity might still be visible</h3>
            <p>
              Incognito doesn't hide your visit from the websites you visit,
              your employer or school, or your internet service provider. Your
              network identity remains active during the session.
            </p>
          </article>
        </section>

        <section class="cookie-section dark-block">
          <h3>Cookies aren’t shared in private incognito</h3>
          <p>
            While in this mode, sites cannot see your existing cookies from your
            main profile. Any cookies created during this session are deleted
            instantly when you exit private browsing.
          </p>
        </section>
      </main>
    </div>
  `;
}

export default renderIncognitoPage;
